import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { type Modal, type ModalsState, moduleName } from "./modals.types";

const initialState: ModalsState = {
	currentModal: null,
};

const modalsSlice = createSlice({
	name: moduleName,
	initialState,
	reducers: {
		showModal: (state, action: PayloadAction<Modal | null>) => {
			state.currentModal = action.payload;
		},
		setModalDisabled: (state, action: PayloadAction<boolean>) => {
			if (state.currentModal) {
				state.currentModal.disabled = action.payload;
			}
		},
	},
});

export default modalsSlice;
